module.exports = __webpack_public_path__ + "img/icon-task-blue.a99574a0.svg";